import React from 'react';

export const Plus3D = () => (
  <svg
    width="128"
    height="131"
    viewBox="0 0 128 131"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.149 69.6254V86.429L92.5114 94.8908L92.6341 111.845L78.0145 120.141L63.1845 111.845L48.4597 120.141L33.9452 111.845V94.9359L19.1152 86.4789V69.6254L33.9452 60.8678V43.9998L48.4597 35.3879L63.1845 43.9998L78.0145 35.3879L92.6341 43.9998V60.9923L107.149 69.6254Z"
      fill="white"
    />
    <path
      d="M33.9452 43.9998L48.4597 35.3879L63.1845 43.9998L78.0145 35.3879L92.6341 43.9998M33.9452 43.9998L48.4597 52.2966L33.9452 60.8678M33.9452 43.9998V60.8678M19.1152 69.6254V86.4789L33.9452 94.9359V111.845L48.4597 120.141M19.1152 69.6254L33.9452 78.1428V61.0713M19.1152 69.6254L33.9452 60.8678M63.1845 94.9359L48.4597 86.4789M63.1845 94.9359L77.8742 86.4789M63.1845 94.9359V111.845M107.149 69.6254V86.429L92.5114 94.8908L92.6341 111.845L78.0145 120.141M107.149 69.6254L92.6341 60.9923M107.149 69.6254L92.6341 78.1428V60.9923M92.6341 43.9998L78.0145 52.2966L92.6341 60.9923M92.6341 43.9998V60.9923M48.4597 120.141L63.1845 111.845M48.4597 120.141V103.369L63.1845 111.845M78.0145 120.141L63.1845 111.845M78.0145 120.141L77.8742 103.352L63.1845 111.845M78.0145 69.6254L92.6341 60.9923M78.0145 69.6254L63.1845 61.0713M78.0145 69.6254L77.8742 86.4789M48.4597 69.6254L33.9452 61.0713M48.4597 69.6254V86.4789M48.4597 69.6254L63.1845 61.0713M33.9452 61.0713V60.8678M48.4597 86.4789L63.1845 78.1428M63.1845 78.1428L77.8742 86.4789M63.1845 78.1428V61.0713"
      stroke="#171717"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.30664 84C7.40463 87.2757 10.0447 89.9041 13.3208 89.9876L13.8066 90L13.3208 90.0124C10.0447 90.0959 7.40463 92.7243 7.30664 96C7.20866 92.7243 4.56856 90.0959 1.29249 90.0124L0.806641 90L1.29249 89.9876C4.56856 89.9041 7.20866 87.2757 7.30664 84Z"
      fill="#262626"
    />
    <path
      d="M116.307 95C116.405 98.2757 119.045 100.904 122.321 100.988L122.807 101L122.321 101.012C119.045 101.096 116.405 103.724 116.307 107C116.209 103.724 113.569 101.096 110.292 101.012L109.807 101L110.292 100.988C113.569 100.904 116.209 98.2757 116.307 95Z"
      fill="#262626"
    />
    <path
      d="M24.5 0C24.7638 9.0079 32.0196 16.2402 41.0283 16.4747L42 16.5L41.0283 16.5253C32.0196 16.7598 24.7638 23.9921 24.5 33C24.2362 23.9921 16.9804 16.7598 7.97169 16.5253L7 16.5L7.97169 16.4747C16.9804 16.2402 24.2362 9.0079 24.5 0Z"
      fill="#262626"
    />
  </svg>
);
